import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./services/store";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import { vue3Debounce } from "vue-debounce";
import money from "v-money3";
import "@/assets/styles/global.scss";
import "quasar/dist/quasar.sass";
import "@/assets/styles/theme.scss";
import VueKonva from "vue-konva";
import { installTruncatedTitles } from "@/utils/truncatedTitle";

createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(VueKonva)
  .use(store)
  .use(router)
  .use(money)
  .directive("debounce", vue3Debounce({ lock: true }))
  .directive("click-outside", {
    mounted(el, binding) {
      el.clickOutsideEvent = function (event) {
        if (!(el === event.target || el.contains(event.target))) {
          binding.value = false;
        }
      };
      document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted(el) {
      document.body.removeEventListener("click", el.clickOutsideEvent);
    },
  })
  .mount("#app");

// полный текст при наведении на любой обрезанный текст (таблицы, поля, меню)
installTruncatedTitles();
